module.exports = __webpack_public_path__ + "assets/img/wh7.5b80fcdb.png";